import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guaranteeCopy } from '../data/content';
export function Guarantee() {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-126" data-mp="1o33smclbhkfn">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-127" data-mp="223y4x6bhk5jl">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-50 ring-1 ring-blue-100" data-id="element-128" data-mp="1x4browvnqpas">
          <ShieldCheckIcon className="h-8 w-8 text-blue-600" aria-hidden="true" data-id="element-129" data-mp="19e7q0v214zmf" />
        </span>

        <h2 className="mt-6 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-130" data-mp="14g65e5oygs8u">
          {guaranteeCopy.title}
        </h2>

        <div className="mx-auto mt-5 max-w-2xl space-y-3 text-lg text-slate-900" data-id="element-131" data-mp="1j6n6tp1lbi5q">
          {guaranteeCopy.paragraphs.map(paragraph => <p key={paragraph} data-id="element-132" data-mp="qnpxorl4061l">{paragraph}</p>)}
        </div>
        <p className="mt-4 font-semibold text-blue-900/70" data-id="element-133" data-mp="qlwrfdeernu4">{guaranteeCopy.closing}</p>
      </div>
    </section>;
}